import { toast } from "@/components/ui";
import { QueryKeys } from "@/constants/Query";
import type { ApiError } from "@/hooks/useApi";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export const useSendCareplan = ({
  carePlanId,
  patientId,
}: { carePlanId: string; patientId: string }) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SEND({
        carePlanId,
        patientId,
      }),
      mutationFn: (careplanId: string) =>
        axiosInstance.post("new-api/chat/careplan/send", {
          careplanId,
        }),
      onError: (error: ApiError) => {
        toast.error(
          error.response?.data?.detail ||
            "Failed to send careplan. Please try again.",
        );
      },
    },
  });
};
